import React from "react";
import Card from "../subviews/Card";
import { getCardData } from "../data/cardData";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/nav.scss";
import parse from "../parse";

class QuestionnaireStart extends React.Component {
  constructor(props) {
    super(props);
    this.buildSection = this.buildSection.bind(this);
    this.buildCard = this.buildCard.bind(this);
    this.buildContent = this.buildContent.bind(this);
  }

  buildSection(section) {
    return (
      <div>
        <h3
          className="card-holder-text"
          style={{ color: this.props.sectionColor }}
        >
          {section.section}
        </h3>
        <p>{section.subtitle}</p>
        {section.cards.map((card) => this.buildCard(card))}
        {section.post_content ? section.post_content.map((card) => this.buildContent(card)) : ""}
      </div>
    );
  }

  buildCard(card) {
    let image = null;
    if (card.image && this.props.cardClass === "pubcard") {
      image = require("../" + card.image);
    }
    return (
      <Card
        cardClass={this.props.cardClass}
        image={image}
        title={card.title}
        text={card.text}
        category={card.category}
        makeSelection={this.props.makeSelection}
        buttonTitle={card.buttonTitle}
        pdf={card.pdf}
        href={card.href}
        target={card.target.href}
        handleButton={this.props.handleButton}
        color={this.props.sectionColor}
        group={this.props.selectionGroup}
        buttonImage={this.props.buttonImage}
      />
    );
  }

  buildContent(content) {
    return (
      <Card
          cardClass={"management " + content.style}
          algorithm={true}
          text={
            <div>
              <div>
                <div className="content">
                  {content.text.map((line) => (
                    <div>{parse(line)}</div>
                  ))}
                </div>
              </div>
            </div>
          }
        />
    );
  }


  render() {
    return (
      <div className="card-holder">
        {getCardData()[this.props.selectionGroup].map((section) =>
          this.buildSection(section)
        )}
      </div>
    );
  }
}

export default QuestionnaireStart;
